import { currentPage, slug, icap, tr } from '../global-pure.js'

const AskLink = ({ text = icap(tr('ask now')), prefill = tr('Hi, I would like to ask a question about')+' '+currentPage()+'.\n...\n'}) => {
  return (<a href={`/${slug('contact')}?n=1&m=${encodeURIComponent(tr(prefill))}`}>{icap(tr(text))}</a>)
}

export default AskLink
